import Repository from '../Repository';
import {AccessForbidden, ImageNotFoundError, ServerError} from '@/api/user/erros';

export default {
  getShopsGroup(token, groupID) {
    return Repository.get(`/administer/shops?groupId=${groupID}`, {
      headers: {
        Authorization: token,
      },
    }).then(response => response.data);
  },
  shopsCrud(token, group) {
    return Repository.post('/administer/shops', group, {
      headers: {
        Authorization: token,
      },
    })
      .then(response => response.data).catch();
  },
  getShopsGroupMockup(groupID) {
    if (groupID === 1) {
      return [
        {
          id: 3,
          name: 'Sala konferencyjna',
          sid: 'sd-k',
          phone: '33333333',
          supervisor: 'Jan Demo',
          address: 'ul. Aleksandrowska 6-10 87-100 Toruń',
          longitude: 18.0,
          latitude: 53.44,
          sensors: [
            {
              id: 20,
              name: 'Sala konferencyjna-1',
              serialNumber: '321',
              portNumber: 1,
              enabled: true,
            },
          ],
          groups: [
            2,
          ],
          sensorIdsToDetach: null,
        },
        {
          id: 2,
          name: 'Salon Demo 2',
          sid: 'sd02',
          phone: '22222222',
          supervisor: 'Jan Demo',
          address: 'ul. Aleksandrowska 6-10 87-100 Toruń',
          longitude: 23.13,
          latitude: 50.50,
          sensors: [
            {
              id: 11,
              name: 'Demo 2 - wejście 1',
              serialNumber: '586',
              portNumber: 1,
              enabled: true,
            },
            {
              id: 12,
              name: 'Demo 2 - wejście 2',
              serialNumber: '586',
              portNumber: 2,
              enabled: true,
            },
          ],
          groups: [
            2,
          ],
          sensorIdsToDetach: null,
        },
        {
          id: 7,
          name: 'nowy salon',
          sid: 'sid123',
          phone: null,
          supervisor: null,
          address: null,
          longitude: 18.26,
          latitude: 53.52,
          sensors: [
            {
              id: 21,
              name: 'uzupelnienie',
              serialNumber: '321',
              portNumber: 2,
              enabled: true,
            },
          ],
          groups: [],
          sensorIdsToDetach: null,
        },
        {
          id: 1,
          name: 'rasbery pi',
          sid: 'sd01',
          phone: '111111111',
          supervisor: 'Jan Demo',
          address: 'ul. Aleksandrowska 6-10 87-100 Toruń',
          longitude: 0.0,
          latitude: 0.0,
          sensors: [
            {
              id: 2,
              name: 'Demo 1 - wejście 1',
              serialNumber: '69b',
              portNumber: 1,
              enabled: true,
            },
            {
              id: 3,
              name: 'Demo 1 - wejście 2',
              serialNumber: '69b',
              portNumber: 2,
              enabled: true,
            },
            {
              id: 4,
              name: 'nowe wejscie 1234',
              serialNumber: '69b',
              portNumber: 3,
              enabled: true,
            },
          ],
          groups: [],
          sensorIdsToDetach: null,
        },
      ];
    }
    return [
      {
        id: 1,
        name: 'rasbery pi',
        sid: 'sd01',
        phone: '111111111',
        supervisor: 'Jan Demo',
        address: 'ul. Aleksandrowska 6-10 87-100 Toruń',
        longitude: 18.0,
        latitude: 53.44,
        sensors: [
          {
            id: 2,
            name: 'Demo 1 - wejście 1',
            serialNumber: '69b',
            portNumber: 1,
            enabled: true,
          },
          {
            id: 3,
            name: 'Demo 1 - wejście 2',
            serialNumber: '69b',
            portNumber: 2,
            enabled: true,
          },
          {
            id: 4,
            name: 'nowe wejscie 1234',
            serialNumber: '69b',
            portNumber: 3,
            enabled: true,
          },
        ],
        groups: [],
        sensorIdsToDetach: null,
      },
    ];
  },
  getLocations(token, groupID) {
    return Repository.get(`/administer/locales?groupId=${groupID}`, {
      headers: {
        Authorization: token,
      },
    }).then(response => response.data);
  },
  getDashboardSingular(token, shopID) {
    return Repository.get(`dashboard?requestShopId=${shopID}&weatherDay=0`, {
      headers: {
        Authorization: token,
      },
    }).then(
      response => response.data,
    ).catch();
  },
  getDashboardMultiple(token, groupID) {
    return Repository.get(`dashboard?groupId=${groupID}`, {
      headers: {
        Authorization: token,
      },
    }).then(
      response => response.data,
    ).catch(
      (error) => {
        if (error.response.status === 500) {
          throw new ServerError();
        }
        if (error.response.status === 403) {
          throw new AccessForbidden();
        }
      },
    );
  },
  getShopImage(token, shopID) {
    return Repository.get(`/dashboard/shop-image/${10252}`, { headers: { Authorization: token } })
      .then(response => response.data)
      .catch((error) => {
        if (e.response.status === 400) {
          throw new ImageNotFoundError();
        }
      });
  },

};
